import React, { useState, useEffect } from 'react';
import { Header, Loader } from 'semantic-ui-react';
import { getInvestorDashboardOverview } from '~/api/dashboard';

const InvestorOverview: React.FC = () => {

    const [overviewData, setOverviewData] = useState<any>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getInvestorDashboardOverview();
                setOverviewData(data);
            } catch (error) {
                console.error('Error fetching investor overview:', error);
            }
        };
        fetchData();
    }, []);


    return (
        <div className="card">
            <Header as="h2">Overview</Header>
            {overviewData ? (
                <div id="investor-overview">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'stretch' }}>
                        <div className="section" style={{ width: '100%' }}>
                            <Header as="h3">{overviewData.totalActiveDeals?.activeDealCount ?? 0} <span>({((overviewData.totalActiveDeals?.totalSizeKwdc ?? 0) / 1000).toFixed(1)} MW)</span></Header>
                            <p>Active deals</p>
                        </div>
                        <div className="section" style={{ width: '100%' }}>
                            <Header as="h3">{((overviewData.totalDealMatches?.totalSizeKwdc ?? 0) / 1000).toFixed(1)} MW</Header>
                            <p>Total matched deals</p>
                        </div>
                        <div className="section" style={{ width: '100%' }}>
                            <Header as="h3">{overviewData.matchToBidRatio ? overviewData.matchToBidRatio : <i>Pending</i>}</Header>
                            <p>Match to bid ratio</p>
                        </div>
                    </div>

                </div>
            ) : (
                <Loader active inline="centered" />
            )}
        </div>
    );
};

export default InvestorOverview;